import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed, inject, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Feature from 'Services/Feature';
import { createAutomation } from 'api/automation/automationService';
import type { PushToast } from 'types/injects/pushToast.type';
import type { Translator } from 'types/injects/translator.type';

interface Props {
    disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AutomationCreateAutomation',
  props: {
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {



const $t = inject('$t') as Translator;
const $pushToast = inject('$pushToast') as PushToast;

const store = useStore();
const route = useRoute();
const router = useRouter();

const translations: Record<string, string> = {
    labelButton: $t.__('automation.AutomationLayout.create_automation'),
    automationTitle: $t.__('automation.AutomationLayout.create_actions_automation'),
    automationCaption: $t.__('automation.AutomationLayout.create_actions_automation_caption'),
    templateTitle: $t.__('automation.AutomationLayout.create_actions_template'),
    templateCaption: $t.__('automation.AutomationLayout.create_actions_template_caption'),
    servicesTitle: $t.__('automation.AutomationLayout.create_actions_services'),
    servicesCaption: $t.__('automation.AutomationLayout.create_actions_services_caption'),
};

const isLoading = ref(false);

const hasAutomationBuilderFeature = computed<boolean>(() =>
    Feature.isEnabled('automations-builder'),
);

const handleCreateAutomation = (): void => {
    isLoading.value = true;
    createAutomation()
        .then((response) => {
            if (response) {
                router.push({
                    name: 'automations.flow.builder',
                    params: { id: response.data.id },
                });
            }
        })
        .catch((error) => {
            store.state.system.errorsHandler.logException(error);
            $pushToast({
                type: 'error',
                close: true,
                text: $t.__('automation.AutomationLayout.error.create_automation'),
            });
        })
        .finally(() => {
            isLoading.value = false;
        });
};

const handleGoToServices = (): void => {
    window.open('https://go.sellsy.com/demande-info-sellsy-services', '_blank');
};

const handleGoToTemplates = (): void => {
    if (route.name === 'automations.templates') {
        return;
    }
    router.push({ name: 'automations.templates' });
};

return (_ctx: any,_cache: any) => {
  const _component_CompassButton = _resolveComponent("CompassButton")!
  const _component_CompassMenuItemExtended = _resolveComponent("CompassMenuItemExtended")!
  const _component_CompassMenu = _resolveComponent("CompassMenu")!

  return (_openBlock(), _createBlock(_component_CompassMenu, {
    placement: _ctx.CompassEnums.MenuPosition.BOTTOM_END,
    customClass: "automation-create-automation__menu",
    disabled: __props.disabled
  }, {
    dropdown: _withCtx(() => [
      _createVNode(_component_CompassMenuItemExtended, {
        icon: "obj-slsy-basic-automation",
        title: translations.templateTitle,
        caption: translations.templateCaption,
        onClick: handleGoToTemplates
      }, null, 8 /* PROPS */, ["title", "caption"]),
      _createVNode(_component_CompassMenuItemExtended, {
        icon: "obj-slsy-advanced-services",
        title: translations.servicesTitle,
        caption: translations.servicesCaption,
        onClick: handleGoToServices
      }, null, 8 /* PROPS */, ["title", "caption"]),
      (hasAutomationBuilderFeature.value)
        ? (_openBlock(), _createBlock(_component_CompassMenuItemExtended, {
            key: 0,
            icon: "obj-slsy-advanced-automation",
            title: translations.automationTitle,
            caption: translations.automationCaption,
            onClick: handleCreateAutomation
          }, null, 8 /* PROPS */, ["title", "caption"]))
        : _createCommentVNode("v-if", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_CompassButton, {
        label: translations.labelButton,
        loading: isLoading.value,
        disabled: __props.disabled,
        dropdown: ""
      }, null, 8 /* PROPS */, ["label", "loading", "disabled"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["placement", "disabled"]))
}
}

})